import { Checkbox } from '@ui/src';
import { DocumentRowHeaderTypes } from '../../types';

import cn from '../../../styles.module.css';

const DocumentsRowHeader = ({
  onGroupSelect,
  documents,
  documentsSelected,
}: DocumentRowHeaderTypes) => (
  <div className={cn.documentsRowHeader}>
    <div className={cn.documentsRowHeaderLeft}>
      <Checkbox
        name="checkbox"
        title="Name"
        onChange={(e) => onGroupSelect(e.target.checked)}
        type="checkbox"
        checked={documentsSelected === documents?.length}
        visualClassName={cn.selectGroupDocumentsVisual}
      />
    </div>
    <div className={cn.documentsRowHeaderRight}>
      <div className={cn.documentsRowHeaderRightContentLeft}>
        <div className={cn.documentsRowHeaderRightItem}>Exp.Date</div>
        <div className={cn.documentsRowHeaderRightItem}>Status</div>
      </div>
    </div>
  </div>
);

export default DocumentsRowHeader;
